<!-- <main class="full-wrap dashboard-page">
    <div class="main-div">
        
        <div class="filterDiv">
            Profit Loss Markets
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="report-table">
                    <table class="table" datatable>
                        <thead>
                            <tr>
                                <th>Sport Name</th>
                                <th>Match Name</th>
                                <th>Market Name</th>
                                <th>Result</th>
                                        <th>Profit / Loss</th>
                                        <th>Commission</th>
                                        <th>Settle Time</th>
                                        
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of profitData;let i = index;">
                                <td  >{{data?.sport_name}}</td>
                                <td >{{data?.match_name}}</td>
                                <td style="cursor: pointer;color:blue;" (click)="userBet(data)">{{data?.event_name}}</td>
                                <td>{{data?.winner_name}}</td>
                                <td  [ngClass]="{'profit':data.user_pl >= 0}"> {{data.user_pl > '0' ? (data.user_pl | number :'0.0-2') : '0'}}</td>
                                <td [ngClass]="{'loss':data.user_commission_pl < 0}">{{data.user_commission_pl < '0' ? (data.user_commission_pl | number :'0.0-2') : '0'}}</td>
                                <td >{{data.result_date| date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="col-inner">
                      <label>Search:</label>
                      <input type="text"  [(ngModel)]="searchMarket" (ngModelChange)="searchFilter()" [ngModelOptions]="{standalone: true}" placeholder="Search Market">
                  </div>
                    <mat-paginator [ngClass]="{'hide':profitData.length ==0 ,'show':profitData.length !=0}"
                                    [length]="statementsTotalItems" [pageSize]="50" #statementPaginatorRef
                                    [pageIndex]="statementsPageIndex" [pageSizeOptions]="[50, 100,150, 200]"
                                    aria-label="Select page" (page)="marketWisePl()">
                                </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</main> -->
<div class="wrapper">
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-12 hide-large featured-box">
                    <!-- <ul class="nav nav-tabs sport-tab">
                        <li class="nav-item"><a class="nav-link active" (click)="goToAll('All')">Home</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="inplay()">In-Play</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="multi()">Multi Markets</a></li>
                        <li class="nav-item" *ngFor="let sports of allSportsList;let i= index"
                          (click)="goToDashboard(sports.name,sports.sport_id,sports)"><a class="nav-link"
                            [ngClass]="{'newlaunch':sports.sport_id <= -100 }">{{sports.name}}</a></li>
                    </ul> -->
                </div>
                <div class="col-md-10 report-main-content m-t-5">
                  <div class="card">
                    <div class="card-header report-header">
                        <h4 class="mb-0">Profit/Loss Markets</h4>
                        <button class="btn btn-primary back-btn" (click)="goToBack()"><i class="fa fa-arrow-left"></i> Back</button>
                    </div>
                    <div class="card-body container-fluid container-fluid-5">
                      <div class="row row5 mt-2">
                        <div class="col-12">
                          <div class="table-responsive">
                            <table class="table b-table dataTable table-striped table-bordered" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                <!-- <thead>
                                  <tr class="text-center">
                                      <th>Sport Name</th>
                                      <th>Match Name</th>
                                      <th>Market Name</th>
                                      <th>Result</th>
                                      <th>Profit / Loss</th>
                                      <th>Commission</th>
                                      <th>Settle Time</th>
                                  </tr>
                                </thead>
                                <tbody *ngIf="profitData?.length != 0">
                                  <tr *ngFor="let data of profitData;let i = index;" style="text-align: center;">
                                      <td >{{data?.sport_name}}</td>
                                      <td >{{data?.match_name}}</td>
                                      <td style="color: #14805e;cursor:pointer" (click)="userBet(data)">{{data?.event_name}}</td>
                                      <td>{{data?.winner_name}}</td>
                                      <td [ngClass]="{'text-danger':data.user_pl < 0 ,'text-success':data.user_pl >= 0}"> {{data.user_pl != '0' ? (data.user_pl | number :'0.0-2') : '0'}}</td>
                                      <td [ngClass]="{'text-danger':data.user_commission_pl < 0}">{{data.user_commission_pl < '0' ? (data.user_commission_pl | number :'0.0-2') : '0'}}</td>
                                      <td>{{data.result_date| date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                                  </tr>
                                </tbody>
                                <tbody *ngIf="profitData?.length == 0">
                                  <tr>
                                    <td class="no-data-available" colspan="3">No data!</td>
                                  </tr>
                                </tbody> -->
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-main></app-footer-main>


<!-- Date Time Picker -->
<ng-template #popTemplateStatementStart>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateStatement" [ngModelOptions]="{standalone: true}" [minDate]="minDate"  [maxDate] ="todayDateTime"[showWeeks]="false"
        (ngModelChange)="updateDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime" (ngModelChange)="updateTimeStatement()" [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplateStatementEnd>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateStatement" [ngModelOptions]="{standalone: true}" [minDate]="dateStatement" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateEndDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime"  (ngModelChange)="updateEndTimeStatement()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>